import { HttpClient } from './types';

export const createBannerService = (httpClient: HttpClient) => {
  const getEndpoint = (url: string): string => `/banners${url}`;

  return {
    getBannersByPosition: <TBanner = any>(position: string): Promise<TBanner[]> => {
      return httpClient.get<TBanner[]>(getEndpoint(`/${position}`));
    },
  };
};

